import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NotificationContext = createContext({ unreadCount: 0, refresh: () => {} });

export const NotificationProvider = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [pollInterval, setPollInterval] = useState(null);

  const getToken = () => localStorage.getItem('token') || localStorage.getItem('providerToken');

  const fetchUnreadCount = useCallback(async () => {
    const token = getToken();
    if (!token) return;
    try {
      const res = await axios.get(`${API}/notifications/unread-count`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUnreadCount(res.data.count);
    } catch {}
  }, []);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/notification-poll-interval`).then(res => {
      if (!cancelled) setPollInterval(res.data.interval * 1000);
    }).catch(() => {
      if (!cancelled) setPollInterval(30000);
    });
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (!pollInterval) return;
    const token = getToken();
    if (!token) return;
    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, pollInterval);
    return () => clearInterval(interval);
  }, [pollInterval, fetchUnreadCount]);

  return (
    <NotificationContext.Provider value={{ unreadCount, refresh: fetchUnreadCount }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationContext);
